






























































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class DashboardPage extends Vue {
  cdnEndpoint: string = process.env.VUE_APP_CDN_URL;
}
